import * as React from "react";

const MOBILE_BREAKPOINT = 768; // Tailwind `md`
const COMPACT_BREAKPOINT = 1024; // Tailwind `lg`


export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = React.useState(() => window.matchMedia(query).matches);

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}


export function useIsCompact() {
  return useMediaQuery(`(max-width: ${COMPACT_BREAKPOINT - 1}px)`);
}
